import React from "react";
import decorationTop from "../../assets/decoration (1).png";
import decorationBottom from "../../assets/decoration.png";
import { MdOutlineArrowBack } from "react-icons/md";
import { useNavigate } from "react-router";

const FormLayout = ({
  title,
  subTitle,
  onSubmit,
  children,
  showGoBack = false,
}) => {
  const navigate = useNavigate();

  return (
    <div className="relative w-full min-h-screen bg-[#d7becf] flex items-center justify-center overflow-hidden">
      <img
        src={decorationBottom}
        alt="Bottom Decoration"
        className="absolute bottom-0 left-0 max-w-[300px] w-full pointer-events-none select-none"
      />
      <img
        src={decorationTop}
        alt="Top Decoration"
        className="absolute top-0 right-0 max-w-[500px] w-full pointer-events-none select-none"
      />
      <div className="w-full lg:max-w-[500px] max-w-[800px] bg-white p-6 sm:p-8 md:p-9 rounded-md z-10">
        {showGoBack && (
          <MdOutlineArrowBack
            className="mb-2 hover:bg-gray-200 p-1 rounded-full hover:text-black"
            size={24}
            title="Go Back"
            onClick={() => navigate("/app/login")}
          />
        )}

        <div className="flex flex-col gap-6 sm:gap-9">
          <img
            src="/newLogo.png"
            alt="sign_image"
            className="object-cover w-44"
          />
          <div>
            <h2 className="text-center">{title}</h2>
            <p className="text-sm text-[#6c757d] text-center leading-6 mt-3">
              {subTitle}
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-5">
            {children}
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
